/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'ai-mate.chat-error-banner.description': 'История чата сохраняется до 30 дней.',
  'ai-mate.chat-error-banner.title': 'Начать новый чат',
  'ai-mate.chat-error.description': 'Попробуйте <btn>перезагрузить чат</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Достигнуто максимальное количество запросов. Повторите попытку позже.',
  'ai-mate.chat-error.rate-limited-title': 'Слишком много запросов',
  'ai-mate.chat-error.rovo-inactive-description': 'Похоже, Rovo не включен на сайте. <link>Настройка Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo неактивен',
  'ai-mate.chat-error.title': 'Мы не знаем, что пошло не так',
  'conversation-assistant-button.label': 'Чат',
  'conversation-assistant-button.rovo-chat-label': 'Чат Rovo',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Спросите об этом AI',
  'highlight-actions.rovo-chat-explain-option.text': 'Объяснить',
  'highlight-actions.rovo-chat-explain-prompt': 'Объясни это: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Рекомендации чата',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Открыть чат',
  'highlight-actions.rovo-chat-summarize-option.text': 'Создать сводку',
  'highlight-actions.rovo-chat-summarize-prompt': 'Обобщить содержимое по ссылке: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Чат',
  'horizontal-scroll-container.scroll-left': 'Прокрутить влево',
  'horizontal-scroll-container.scroll-right': 'Прокрутить вправо',
};
